import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import * as actions from './actions';
import AsyncElements from '../../components/AsyncElements';

class GoogleOAuthContainer extends React.Component {
  componentDidMount() {
    const routeMatch = (this.props.location.search || '').match(/code=(.*)/)
    const code = routeMatch ? routeMatch[1] : ''
    this.props.dispatch(actions.submitAuthorizationCode(code))
  }

  // If possible, redirect to the class that the user left the dashboard from
  redirectionLocation() {
    const id = localStorage.getItem('sectionId')
    let path = '/classes'

    if(id) {
      path = `/classes/${id}?import=true`
      localStorage.removeItem('sectionId')
    }

    return path
  }

  render() {
    const { isSubmitting, submitError, submitWasSuccessful } = this.props

    return(
      <AsyncElements isLoading={isSubmitting} fetchError={submitError}>
        {submitWasSuccessful && <Redirect to={this.redirectionLocation()}/>}
        {!submitWasSuccessful && <div></div>}
      </AsyncElements>
    );
  }
}

export default connect(state=>state.googleOAuth)(GoogleOAuthContainer);
